import { LOG_TRANSPORTS } from '../log-transports.token'
import { LoggerFeature, LoggerFeatureKind } from '../provide-logger'
import { CloudWatchLogTransport } from './cloud-watch-log-transport.service'
import { CLOUD_WATCH_LOG_TRANSPORT_CONFIG } from './cloud-watch-log-transport-config.injection-token'
import { CloudWatchLogTransportConfig } from './cloud-watch-log-transport-config.type'
import { CloudWatchLogger } from './cloud-watch-logger.service'

export function withCloudwatchTransport(
  cloudWatchLogTransportConfigOrFactory: CloudWatchLogTransportConfig | (() => CloudWatchLogTransportConfig),
): LoggerFeature {
  const configProvider =
    typeof cloudWatchLogTransportConfigOrFactory === 'function'
      ? { provide: CLOUD_WATCH_LOG_TRANSPORT_CONFIG, useFactory: cloudWatchLogTransportConfigOrFactory }
      : { provide: CLOUD_WATCH_LOG_TRANSPORT_CONFIG, useValue: cloudWatchLogTransportConfigOrFactory }

  return {
    kind: LoggerFeatureKind.TRANSPORT,
    providers: [
      CloudWatchLogger,
      configProvider,
      { provide: LOG_TRANSPORTS, useClass: CloudWatchLogTransport, multi: true },
    ],
  }
}
